import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center">
      <div className="absolute inset-0 flex">
        <div className="w-full md:w-1/2 bg-background-50"></div>
        <div className="hidden md:block md:w-1/2 relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20artistic%20illustration%20style%2C%20warm%20brown%20and%20cream%20tones%2C%20abstract%20comic%20panel%20background%2C%20soft%20gradient%2C%20elegant%20minimalist%20design%2C%20Korean%20webtoon%20aesthetic%2C%20artistic%20brush%20strokes%2C%20warm%20atmospheric%20lighting%2C%20subtle%20texture%2C%20no%20text&width=960&height=680&seq=hero-comic-bg&orientation=landscape"
            alt="韩国漫画艺术背景"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/20 to-transparent"></div>
        </div>
      </div>

      <div className="relative z-10 w-full">
        <div className="w-full px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 items-center min-h-[560px] md:min-h-[680px]">
            <div className="flex flex-col justify-center py-16 md:py-0">
              <span className="text-xs font-medium tracking-widest uppercase text-primary-500 mb-4">
                免费韩国漫画在线阅读平台
              </span>
              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-foreground-900 leading-tight">
                韩国漫画
                <br />
                在线阅读
              </h1>
              <p className="mt-5 text-sm md:text-base text-foreground-500 leading-relaxed max-w-md">
                免费漫画大全，好看的韩漫推荐。采用无遮挡下拉式阅读模式，
                <br className="hidden md:block" />
                确保在线体验舒适流畅，让您专注于漫画情节本身。
              </p>
              <div className="mt-8 flex items-center gap-3">
                <Link
                  to="/category/all"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors"
                >
                  开始阅读
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/about"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-foreground-900 text-foreground-900 text-sm font-medium hover:bg-foreground-900 hover:text-background-50 transition-colors"
                >
                  了解更多
                </Link>
              </div>
              <div className="mt-10 flex items-center gap-6">
                <div className="text-center">
                  <span className="block text-2xl font-bold text-foreground-800">5,000+</span>
                  <span className="text-xs text-foreground-400">收录漫画</span>
                </div>
                <div className="w-px h-10 bg-background-300"></div>
                <div className="text-center">
                  <span className="block text-2xl font-bold text-foreground-800">80万+</span>
                  <span className="text-xs text-foreground-400">日活用户</span>
                </div>
                <div className="w-px h-10 bg-background-300"></div>
                <div className="text-center">
                  <span className="block text-2xl font-bold text-foreground-800">98.6%</span>
                  <span className="text-xs text-foreground-400">好评率</span>
                </div>
              </div>
            </div>

            <div className="hidden md:block"></div>
          </div>
        </div>
      </div>
    </section>
  );
}